import { RiskIncidentPanelWebView } from '../view/RiskIncidentPanelWebView';
import { templateRiskIncidentPanel } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { RiskIncidentPanelWebComponent } from '..';
import { CloudSecuritySectionEvents, RisksIncidentOverviewEvents } from '../types';
import { ButtonEvents } from '../../../ui/gzButton/types';
import { SideMenuWidthValues } from '../../../ui/gzSideMenu/types';
import { RiskIncidentSidePanelWebComponent } from '../../riskIncidentSidePanel';
import { GzDonutChartEvents } from '../../../ui/gzGeneralDonutChart/types';
import { NavigationConstants, NavigationHelper } from '@nirvana/shared/navigation';
import { RisksOverviewSectionEvents } from '../../riskIncidentOverviewSection/types';

export class RiskIncidentPanelWebController extends BaseWebComponentController {
  public component: RiskIncidentPanelWebComponent;
  public view: RiskIncidentPanelWebView;
  public viewConstructor: typeof RiskIncidentPanelWebView;

  constructor(component: RiskIncidentPanelWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: RiskIncidentPanelWebView,
      viewTemplate: templateRiskIncidentPanel,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$viewAllRisksButton,
        event: ButtonEvents.CLICK,
        callback: this.viewSidePanel,
      },
      {
        element: this.view.dom.$containerForSections,
        event: RisksIncidentOverviewEvents.VIEW_ALL_RISKS,
        callback: this.viewSidePanel,
      },
      {
        element: this.view.dom.$donutChart,
        event: GzDonutChartEvents.OPEN_SIDE_PANEL_RISKS,
        callback: this.clickOnPieChart,
      },
      {
        element: this.view.dom.$cloudSecuritySection,
        event: RisksOverviewSectionEvents.CLICK_ON_CUSTOM_BUTTON,
        callback: this.getLicense,
      },
    ];
  }

  private getLicense(event: CustomEvent): void {
    if (event.detail.eventType === CloudSecuritySectionEvents.CLICK_ON_GET_LICENSE) {
      NavigationHelper.drillDownToMyCompany(NavigationConstants.MY_COMPANY.TABS.LICENSING);
    }
  }

  private clickOnPieChart(event: CustomEvent): void {
    if (event.detail.idChart) {
      event.detail.type = event.detail.idChart;
      this.viewSidePanel(event);
    }
  }

  private viewSidePanel(event: CustomEvent): void {
    const xdrOverview = document.body.querySelector('gz-xdr-overview');
    const xdrOverviewShadow = xdrOverview?.shadowRoot;
    const sideMenu: any = xdrOverviewShadow?.querySelector('gz-side-menu');
    let typeOfRisk = '';

    if (event.detail.type) {
      typeOfRisk = event.detail.type;
    }

    const riskIncidentSidePanel = new RiskIncidentSidePanelWebComponent(this.component.incidentId, this.view.companyId, typeOfRisk);
    riskIncidentSidePanel.injectDependencies(this.dependencies);
    riskIncidentSidePanel.start().then().catch();

    sideMenu.setMenuContent(riskIncidentSidePanel);
    sideMenu.openSideMenu();
    sideMenu.closeOnClickOutside = true;
    sideMenu.menuWidth = SideMenuWidthValues.MEDIUM;
    const sideMenuShadow = sideMenu?.shadowRoot;
    const resizeHandler = sideMenuShadow?.querySelector('#resizeHandler');
    resizeHandler.style.setProperty('z-index', '1');
  }

  async getDataForView(): Promise<any> {
    return Promise.all([
      this.dependencies.getXdrRisksSummary(this.component.incidentId),
      this.dependencies.countXdrRisksEntities(this.component.incidentId),
    ]);
  }
}
